import ApiService from "@/common/api/api.service";

let endpoint = "Projeto";

const Entregavel = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    salvarDesembolsoNaoPrevisto(form) {
        if(form.id)
            return ApiService.put(`${endpoint}/cronograma-financeiro`, form);
        return ApiService.post(`${endpoint}/cronograma-financeiro`, form);
    },

    salvarDesembolso(form) {
        return ApiService.put(`${endpoint}/desembolso`, form);
    },

    deletarDesembolso(form){
        return ApiService.delete(`${endpoint}/cronograma-financeiro`, form);
    },

    aprovarDesembolso(id){
        return ApiService.put(`${endpoint}/aprovar-desembolso?id=${id}`);
    },

    reprovarDesembolso(id){
        return ApiService.put(`${endpoint}/reprovar-desembolso?id=${id}`);
    }
}

export default Entregavel;
